import React, { useEffect, useState } from 'react';
import { Modal } from '../shared/Modal';
import { reportService } from '../../services/reportService';
import { reportAdminService } from '../../services/reportAdminService';
import { mapSupabaseError } from '../../utils/supabaseErrors';
import { formatPeriodLabel } from '../submissions/periodFormat';
import { mergeReportContent, normalizeReportForExport, buildSingleReportRows, reportFilename } from '../../utils/reportExport';
import { toCsv, downloadCsv } from '../../utils/csv';

export function ReportsSubmissionDetailModal({ submission, onClose }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const [fields, content] = await Promise.all([
          reportAdminService.getReportSystemFields(submission.report_system_id),
          reportService.getSubmissionReport(submission.id),
        ]);
        if (!active) return;
        const merged = mergeReportContent(fields, content);
        setRows(merged);
      } catch (e) {
        if (active) setError(mapSupabaseError(e));
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, [submission.id, submission.report_system_id]);

  const handleExport = () => {
    const norm = normalizeReportForExport(submission, rows);
    downloadCsv(reportFilename(norm), toCsv(buildSingleReportRows(norm)));
  };

  return (
    <Modal onClose={onClose} role="dialog" aria-modal="true" aria-label="Report submission detail">
      <h3>Report submission</h3>
      <p className="form-label"><strong>{submission.submitter?.name}</strong> · {formatPeriodLabel(submission.period, submission.period_start, submission.period_end)}</p>
      {error && <div className="error-message" role="alert">{error}</div>}
      {loading ? <p className="loading-msg">Loading…</p> : (
        rows.length === 0 ? <p className="submissions-empty">This report has no content.</p> : (
          <table className="kpi-bundle-table">
            <thead><tr><th>Field</th><th>Value</th></tr></thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id}>
                  <td>{r.label}</td>
                  <td className="report-value">{r.value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )
      )}
      <div className="modal-buttons">
        {rows.length > 0 && <button type="button" className="btn-secondary" onClick={handleExport}>Export CSV</button>}
        <button type="button" className="btn-secondary" onClick={onClose}>Close</button>
      </div>
    </Modal>
  );
}
